var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.2712,
    height: 76.2712,
    rx: 16,
    fill: "url(#paint0_radial_186_3498)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4064 44.2373L26.4664 49.8044L32.0335 51.8644L26.4664 53.9244L24.4064 59.4915L22.3464 53.9244L16.7793 51.8644L22.3464 49.8044L24.4064 44.2373Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8809,
    y: 32.0342,
    width: 9.15254,
    height: 9.15254,
    rx: 1.52542,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2871,
    y: 32.0342,
    width: 9.15254,
    height: 9.15254,
    rx: 1.52542,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2871,
    y: 44.2373,
    width: 9.15254,
    height: 9.15254,
    rx: 1.52542,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8809,
    y: 19.8301,
    width: 9.15254,
    height: 9.15254,
    rx: 1.52542,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.084,
    y: 47.2881,
    width: 9.15254,
    height: 6.1017,
    rx: 1.52542,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35.084,
    y: 35.085,
    width: 9.15254,
    height: 6.1017,
    rx: 1.52542,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2871,
    y: 19.8301,
    width: 9.15254,
    height: 9.15254,
    rx: 1.52542,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_186_3498",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.2712 4.07973e-06) rotate(135) scale(107.864 96.7979)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF658A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6212CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantStudent);
export default __webpack_public_path__ + "static/media/assistant-student.61711906.svg";
export { ForwardRef as ReactComponent };